export default function(value: string): boolean {
    if (!value.startsWith('http')) {
        value = `https://${value}`;
    }
    if (value.length > 2048) {
        return false;
    }

    return /^(https?:\/\/)?((localhost|[\da-z.-]+)\.([a-z.]{2,})?|localhost|(\d{1,3}\.){3}\d{1,3})(:[0-9]{1,5})?(\/[^\s]*)?(\?[^\s]*)?$/i.test(value);
}
